import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import { Material } from '../../../models';
import { inchToString } from '../../../lib/unitConversions';

const styles = function(theme){
  return {
    root: {
      display: 'flex',
      flexBasis: '100%'
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '33.33%',
      flexShrink: 0,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
    materialType: {
      fontWeight: 'bold',
    }
  }
}

const resinPercentString = (num) => ` (${num}% resins)`;

export const MaterialSummary = ({ classes, material, lengthUnit }) => (
  <div className={classes.root}>
    <div className={classes.heading}>
      <Typography className={classes.materialType}>
        { material.type }
      </Typography>
      <Typography className={classes.heading}>
        {material.product}
      </Typography>
    </div>
    <Typography className={classes.secondaryHeading}>
      {inchToString(material.thickness, lengthUnit)}
      {' ● '}
      {material.construction}
      {material.resinContentPercent && 
        resinPercentString(material.resinContentPercent)}
    </Typography>
  </div>
);

MaterialSummary.propTypes = {
  classes:  PropTypes.shape({
    root: PropTypes.string,
    heading: PropTypes.string,
    secondaryHeading: PropTypes.string,
    materialType: PropTypes.string,
  }).isRequired,
  material: PropTypes.instanceOf(Material).isRequired,
  lengthUnit: PropTypes.string.isRequired,
};

export default withStyles(styles)(MaterialSummary);



// WEBPACK FOOTER //
// ./src/components/common/MaterialPanel/MaterialSummary.js